<template>
    <div>
        <div class="reply_base_Style">
            <div class="reply_title">Comments details
            </div>
            <div class="postTitleStyle">
                <div class="det_close" @click="closeDetails"></div>
            </div>
        </div>

        <div class="line_8"></div>

        <div class="item_comment_layout">

            <img v-if="details.user.avatar" :src="details.user.avatar" class="user_logo">

            <img v-else :src="defheader_img" class="user_logo" />

            <div class="item_comment_layout_column_flex">
                <div class="comment_name_layout">

                    <div class="user_name">{{ details.user.nickname }}</div>
                    <star-rating :rating="details.score" :read-only="true" :show-rating="false" :increment="0.1"
                        :star-size="14" style="margin-left: 4px; margin-right: 4px;margin-bottom: 4px;" />
                    <div class="relo_comment" v-if="details.user.role">
                        {{ details.user.role }}
                    </div>
                    <div class="comment_time">{{ details.comment.comment_date }}</div>


                </div>


                <div class="comment_data">{{ details.comment.comment_content }}</div>


                <div class="item_comment_layout_row">

                    <div class="comment_good_layout" @click="addGood(details)">
                        <img :src="imgGoodf" v-if="details.isGood" class="goodIcon_layout">
                        <img :src="imgGood" v-else class="goodIcon_layout">
                        <div>{{ details.good }}</div>
                    </div>
                    <div class="comment_good_layout" style="margin-left: 40px;" @click="rePCommentView(details)"
                        v-show="!details.replay">
                        <img :src="imgreply" class="goodIcon_layout">
                        <div>Reply</div>
                    </div>
                </div>

            </div>

            <div></div>

        </div>


        <div class="line_1"></div>

        <div class="reply_base_Style">
            <div class="reply_h2">Comments details ({{ details.replies.length }})
            </div>
            <div class="reply_h2">
                <div class="by_time"></div>
                By time
            </div>
        </div>


        <div v-for="(comment) in details.replies" :key="comment['id']">

            <div class="row_layout">

                <img v-if="comment.user.avatar" :src="comment.user.avatar" class="user_logo">
                <img v-else :src="defheader_img" class="user_logo" />
                <div>


                    <div class="comment_child_name_layout">

                        <div class="user_name_child">{{ comment.user.nickname }}</div>

                        <div class="comment_time_child">{{ comment.comment.comment_date_gmt }}</div>
                    </div>

                    <div class="comment_data">{{ comment.comment.comment_content
                        }}</div>
                </div>

            </div>

        </div>

        <div class="line_1"></div>

        <postCommentView :comment_parent="details.comment.comment_ID" :isShowPostStar="false">
        </postCommentView>

    </div>
</template>
<script>

import StarRating from "vue-star-rating";
import defheader from '../assets/default_avatar.png';
import goodIcon from '../assets/good.png';
import replyIcon from '../assets/replies.png';
import postCommentView from './postCommentView.vue';
import goodfIcon from '../assets/icon_goodf.png';
import { AccountStore } from "../util/Account.js";
export default {
    name: 'replyCommentDetailsView',
    components: {
        StarRating,
        postCommentView
    },
    emits: ['clickDetaits', 'goodClick'],
    props: {
        details: {},
    },
    data() {
        return {
            imgGood: "",
            imgreply: "",
            comments: [],
            imgGoodf: "",
            // details: {
            //     "comment": {
            //         "comment_ID": "25",
            //         "comment_post_ID": "33",
            //         "comment_author": "653b5da4e96a4a0006842d60@bee.com",
            //         "comment_author_email": "653b5da4e96a4a0006842d60@bee.com",
            //         "comment_author_url": "653b5da4e96a4a0006842d60@bee.com",
            //         "comment_author_IP": "",
            //         "comment_date": "2024-08-21 04:01:59",
            //         "comment_date_gmt": "2024-08-20 20:01:59",
            //         "comment_content": "\u201c\u8fd9\u4e2a\u7f51\u7ad9\u627e\u9879\u76ee\u5f88\u65b9\u4fbf\u201d\u53ef\u4ee5\u4f18\u5316\u4e3a\u201c\u5728\u8fd9\u4e2a\u7f51\u7ad9\u4e0a\u627e\u9879\u76ee\u7b80\u76f4\u592a\u65b9\u4fbf\u4e86\uff01\u201d\n\n\u6709\u8da3\u7684\u56de\u590d\u53ef\u4ee5\u662f\uff1a\n\u201c\u54c8\u54c8\uff0c\u7b80\u76f4\u50cf\u662f\u9879\u76ee\u754c\u7684\u2018\u6dd8\u5b9d\u2019\uff0c\u4e00\u641c\u5c31\u6709\uff01\u201d",
            //         "comment_karma": "0",
            //         "comment_approved": "1",
            //         "comment_agent": "",
            //         "comment_type": "comment",
            //         "comment_parent": "0",
            //         "user_id": "0"
            //     },
            //     "user": {
            //         "user_id": "653b5da4e96a4a0006842d60@bee.com",
            //         "name": "653b5da4e96a4a0006842d60@bee.com",
            //         "email": "653b5da4e96a4a0006842d60@bee.com",
            //         "avatar": "",
            //         "nickname": "653b5da4",
            //         "description": "",
            //         "role": [
            //             "subscriber"
            //         ]
            //     },
            //     "score": "",
            //     "replies": [
            //         {
            //             "comment": {
            //                 "comment_ID": "41",
            //                 "comment_post_ID": "0",
            //                 "comment_author": "jsss",
            //                 "comment_author_email": "243160686@qq.com",
            //                 "comment_author_url": "243160686@qq.com",
            //                 "comment_author_IP": "",
            //                 "comment_date": "2024-10-18 15:36:08",
            //                 "comment_date_gmt": "2024-10-18 07:36:08",
            //                 "comment_content": "\u4e0d\u9519\u554a",
            //                 "comment_karma": "0",
            //                 "comment_approved": "1",
            //                 "comment_agent": "",
            //                 "comment_type": "comment",
            //                 "comment_parent": "25",
            //                 "user_id": "0"
            //             },
            //             "user": {
            //                 "user_id": "jsss",
            //                 "name": "jsss",
            //                 "email": "243160686@qq.com",
            //                 "avatar": "",
            //                 "nickname": "jsss",
            //                 "description": "M&amp;EoALv7*BjefCCWXJVgwnUW",
            //                 "role": []
            //             }
            //         }
            //     ]
            // },
        }
    },

    methods: {
        closeDetails() {
            this.$emit("clickDetaits", 0);
        },

        async addGood(item) {
            this.$emit("goodClick", 0);
        }
    },

    mounted() {
        this.imgGood = goodIcon;
        this.defheader_img = defheader;
        this.imgreply = replyIcon;
        this.imgGoodf = goodfIcon;
    },
}


</script>

<style scoped>
.reply_base_Style {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.reply_title {
    font-family: SF Pro Text;
    font-size: 20px;
    font-weight: 600;
    line-height: 22px;
    text-align: left;
    color: #000;
}

.by_time {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    background-image: url("../assets/icon_by_time.png");
    background-size: cover;
    background-repeat: no-repeat;
    margin-right: 2px;
}

.det_close {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    background-image: url("../assets/icon_closeDt.png");
    background-size: cover;
    background-repeat: no-repeat;
    cursor: pointer;
}

.item_comment_layout {
    display: flex;
    flex-direction: row;
}

.item_comment_layout_row {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.item_comment_layout_column_flex {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.item_comment_layout_column {
    display: flex;
    flex-direction: column;
}

.comment_name_layout {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
}

.comment_child_name_layout {
    display: flex;
    flex-direction: row;
    align-items: end;
}

.user_logo {
    width: 38px;
    height: 38px;
    border-radius: 100%;
    margin-right: 8px;
}

.user_chilid_logo {
    width: 20px;
    height: 20px;
    border-radius: 100%;
    margin-right: 8px;
}

.comment_time {
    color: #6c757d !important;
    font-size: 12px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.comment_data {
    font-size: 14px !important;
    color: #1d232b;
    margin-top: 8px;
    margin-bottom: 6px;
}

.user_chilid_logo {
    width: 20px;
    height: 20px;
    border-radius: 100%;
    margin-right: 8px;
}

.comment_time {
    color: #6c757d !important;
    font-size: 12px !important;
}

.comment_data {
    font-size: 14px !important;
    color: #1d232b;
    margin-top: 8px;
    margin-bottom: 6px;
}

.user_name {
    font-size: 16px !important;
    color: #666666;
    font-family: SF Pro Text;
    font-weight: 500;
    line-height: 19.09px;
    text-align: left;
}

.reply_user_name {
    font-size: 16px !important;
    color: #0078B2;
    font-family: SF Pro Text;
    font-weight: 400;
    line-height: 19.09px;
    text-align: left;
}


.comment_good_layout {
    color: #6c757d !important;
    font-size: 14px !important;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
}

.relo_comment {
    border-radius: 4px;
    border: 0.5px solid #FFAC13;
    padding-top: 2px;
    padding-bottom: 2px;
    padding: 2px 4px;
    font-family: SF Pro Text;
    font-size: 12px;
    font-weight: 400;
    line-height: 14.32px;
    color: #FFAC13;
    margin-right: 4px;
}

.goodIcon_layout {
    width: 16px;
    height: 16px;
    margin-right: 6px;
}

.line_1 {
    border: 1px solid #EFEFEF;
    display: flex;
    margin-bottom: 12px;
    margin-top: 12px;
}

.line_8 {
    height: 8px;
    background-color: #f8f8f8;
    display: flex;
    margin-bottom: 12px;
}

.reply_h2 {
    color: #999999;
    font-family: SF Pro Text;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    display: flex;
    align-items: center;
}

.row_layout {
    display: flex;
    flex-direction: row;
}

.comment_time {
    color: #6c757d !important;
    font-size: 12px !important;
}

.comment_data {
    font-size: 14px !important;
    color: #1d232b;
    margin-top: 8px;
    margin-bottom: 6px;
}

.user_name_child {
    font-family: SF Pro Text;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.09px;
    text-align: left;
    color: #0078B2;
    margin-right: 4px;
}

.comment_time_child {
    color: #999;
    font-family: SF Pro Text;
    font-size: 12px;
    font-weight: 400;
    line-height: 14.32px;
    text-align: left;
}
</style>